import '/app/brewery-packages/content/content-editor-plugin-emphasis/src/Emphasis.css-raw';
export default {
  "emphasis": "employees-21b62107-emphasis-Ihm-DG"
};